// Recovered compiled webpack factory 25426. Edit this function expression; run npm run build.
(e, t, n) => {
  Promise.resolve().then(n.bind(n, 28731));
}
